document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".js-inspired-video");
  if (!videos.length) return;

  videos.forEach(video => {
    video.addEventListener("mouseenter", () => {
      video.play().catch(() => {});
    });

    video.addEventListener("mouseleave", () => {
      video.pause();
      video.currentTime = 0;
    });

    // mobile tap
    video.addEventListener("touchstart", () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  });
});
